import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "card", "input", "leftArrow", "rightArrow", "pagination", "searchInput"]

  connect() {
    this.currentIndex = 0
    this.cardWidth = 200 // w-48 = 192px + gap
    this.allCards = this.cardTargets
    this.filteredCards = this.cardTargets
    this.updateArrows()
    this.updatePagination()
  }

  selectLayout(event) {
    const layoutId = event.currentTarget.dataset.layoutId
    
    // Update all cards
    this.cardTargets.forEach(card => {
      if (card.dataset.layoutId === layoutId) {
        card.classList.remove('border-gray-200', 'hover:border-gray-300')
        card.classList.add('border-blue-500', 'bg-blue-50')
        
        // Show selection indicator
        const indicator = card.querySelector('.absolute.top-2.right-2')
        if (indicator) {
          indicator.classList.remove('opacity-0')
          indicator.classList.add('opacity-100')
        }
      } else {
        card.classList.remove('border-blue-500', 'bg-blue-50')
        card.classList.add('border-gray-200', 'hover:border-gray-300')
        
        // Hide selection indicator
        const indicator = card.querySelector('.absolute.top-2.right-2')
        if (indicator) {
          indicator.classList.remove('opacity-100')
          indicator.classList.add('opacity-0')
        }
      }
    })
    
    // Update hidden input
    this.inputTarget.value = layoutId
    
    // Update pagination
    this.updatePagination()
    
    // Scroll to selected card
    this.scrollToCard(event.currentTarget)
  }

  scrollLeft() {
    if (this.currentIndex > 0) {
      this.currentIndex--
      this.scrollToIndex()
    }
  }

  scrollRight() {
    const maxIndex = this.cardTargets.length - 1
    if (this.currentIndex < maxIndex) {
      this.currentIndex++
      this.scrollToIndex()
    }
  }

  goToSlide(event) {
    this.currentIndex = parseInt(event.currentTarget.dataset.slideIndex)
    this.scrollToIndex()
  }

  scrollToIndex() {
    const card = this.cardTargets[this.currentIndex]
    if (card) {
      this.scrollToCard(card)
    }
    this.updateArrows()
    this.updatePagination()
  }

  scrollToCard(card) {
    const container = this.containerTarget
    const cardRect = card.getBoundingClientRect()
    const containerRect = container.getBoundingClientRect()
    
    const scrollLeft = card.offsetLeft - (containerRect.width / 2) + (cardRect.width / 2)
    
    container.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    })
  }

  updateArrows() {
    const maxIndex = this.cardTargets.length - 1
    
    // Left arrow
    if (this.currentIndex <= 0) {
      this.leftArrowTarget.classList.add('opacity-50', 'cursor-not-allowed')
      this.leftArrowTarget.disabled = true
    } else {
      this.leftArrowTarget.classList.remove('opacity-50', 'cursor-not-allowed')
      this.leftArrowTarget.disabled = false
    }
    
    // Right arrow
    if (this.currentIndex >= maxIndex) {
      this.rightArrowTarget.classList.add('opacity-50', 'cursor-not-allowed')
      this.rightArrowTarget.disabled = true
    } else {
      this.rightArrowTarget.classList.remove('opacity-50', 'cursor-not-allowed')
      this.rightArrowTarget.disabled = false
    }
  }

  updatePagination() {
    this.paginationTargets.forEach((dot, index) => {
      if (index === this.currentIndex) {
        dot.classList.remove('bg-gray-300', 'hover:bg-gray-400')
        dot.classList.add('bg-blue-600')
      } else {
        dot.classList.remove('bg-blue-600')
        dot.classList.add('bg-gray-300', 'hover:bg-gray-400')
      }
    })
  }

  // Handle scroll events to update current index
  handleScroll() {
    const container = this.containerTarget
    const scrollLeft = container.scrollLeft
    const cardWidth = this.cardWidth
    
    this.currentIndex = Math.round(scrollLeft / cardWidth)
    this.updateArrows()
    this.updatePagination()
  }

  // Filter layouts based on search input
  filterLayouts(event) {
    const searchTerm = event.target.value.toLowerCase()
    
    this.cardTargets.forEach(card => {
      const title = card.dataset.layoutTitle
      if (title.includes(searchTerm)) {
        card.style.display = 'block'
      } else {
        card.style.display = 'none'
      }
    })
    
    // Update filtered cards array
    this.filteredCards = this.cardTargets.filter(card => card.style.display !== 'none')
    
    // Reset current index if needed
    if (this.currentIndex >= this.filteredCards.length) {
      this.currentIndex = Math.max(0, this.filteredCards.length - 1)
    }
    
    this.updateArrows()
    this.updatePagination()
  }
}
